module.exports = __webpack_public_path__ + "Material-Design-Icons.2f198897e99efe0341f7.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/material-design-icons/Material-Design-Icons.eot
// module id = ../../../../../src/assets/font/material-design-icons/Material-Design-Icons.eot
// module chunks = 29